import BenchlingConfig from 'BenchlingConfig';

export function isSimpleRulesEnabled(): boolean {
  return (
    BenchlingConfig.VALIDATION_RULES_ENGINE_ENABLE_M3 ||
    BenchlingConfig.MOLBIO_ENABLE_AUTOFILL_CONFIGURABILITY
  );
}
